class CartExtraUpsells extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.cart = document.querySelector('cart-drawer');
    this.productFormEls = this.querySelectorAll('form[data-product-form]');


    this.cartIsValid = this.dataset.cartIsValid === '';
    this.maxCartLimitReached = this.dataset.maxCartLimitReached === '';

    // GWP
    this.gwpElement = document.getElementById('vbb-cart-gwp-accordion');
    this.gwpElementJson = this.gwpElement.dataset.gwpJson ? JSON.parse(this.gwpElement.dataset.gwpJson) : [];
    this.cartTotalPrice = Number(this.gwpElement.dataset.cartTotalPrice);

    this.autoAddVariantIds = this.gwpElementJson
      .filter((gift) => {
        return (
          gift.variant_in_stock &&
          gift.auto_add_enable &&
          gift.auto_add_cart_total_price_threshold != undefined &&
          !gift.is_in_cart &&
          this.cartTotalPrice >= gift.auto_add_cart_total_price_threshold
        );
      })
      .map((gift) => gift.variant.id);


      this.autoRemoveVariantIds = this.gwpElementJson
      .filter((gift) => {
        return (gift.is_in_cart && (
          !gift.variant_in_stock ||
          (gift.auto_add_enable &&
          gift.auto_add_cart_total_price_threshold != undefined &&
          gift.is_in_cart &&
          this.cartTotalPrice < gift.auto_add_cart_total_price_threshold) || this.cartTotalPrice < gift.cart_threshold)
        );
      }).map((gift) => gift.variant.id);

    // PWP
    this.pwpId = this.dataset.pwpId;
    this.pwpInStock = this.dataset.pwpInStock;
    this.pwpThreshold = Number(this.dataset.pwpThreshold);
    this.pwpIsInCart = this.dataset.pwpIsInCart === 'true';
    this.pwpEligible = this.dataset.pwpEligible === 'true';

    this.timeout = setTimeout(() => this.autoAddAndOrRemove(), 300);

    this.onSubmitProductForm = this.onSubmitProductForm.bind(this);
    this.productFormEls.forEach((form) =>
      form.addEventListener('submit', this.onSubmitProductForm)
    );
  }

  disconnectedCallback() {
    clearTimeout(this.timeout);
    this.productFormEls.forEach((form) =>
      form.removeEventListener('submit', this.onSubmitProductForm)
    );
  }

  autoAddAndOrRemove() {
    if (this.autoAddVariantIds.length > 0) {
      const form = this.querySelector('form');
      if(!form) {
        console.error('No form found to add GWP to cart');
        return;
      };
      this.addToCart(form, this.autoAddVariantIds, false);
    } else if (this.autoRemoveVariantIds.length > 0) {
      this.removeFromCart(this.autoRemoveVariantIds);
    }

    if (!this.pwpEligible && this.pwpIsInCart) {
      this.removeFromCart([this.pwpId]);
    }
  }

  onSubmitProductForm(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const form = event.currentTarget;
    this.addToCart(form, undefined, true);
  }

  addToCart(formElement, variantIds = null, removable = true, purchase = true) {
    if (this.classList.contains('is-loading')) return;

    this.classList.add('is-loading');

    const formData = new FormData();
    const sections = this.cart.getSectionsToRender().map((s) => s.id);
    formData.set('sections', sections);

    const ids = variantIds ??
      [...formElement.querySelectorAll('input[name="id"]')].map((i) => i.value);

    ids.forEach((id, index) => {
      formData.append(`items[${index}][id]`, id);
      formData.append(`items[${index}][quantity]`, '1');

      if (removable) {
        formData.append(`items[${index}][properties][_gwp-item-removable]`, 'true');
      }

      // Also append any additional custom line item properties from the form
      if (formElement) {
        const propertyInputs = formElement.querySelectorAll('input[name^="properties["]');
        propertyInputs.forEach((input) => {
          const match = input.name.match(/^properties\[(.+?)\]$/);
          if (match) {
            formData.append(`items[${index}][properties][${match[1]}]`, input.value);
          }
        });
      }
    });

    this.cart.open();
    this.cart.setLoading();

    fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      body: formData
    })
      .then((res) => res.ok ? res.json() : Promise.reject(res))
      .then((res) => {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vbb-cart-extra-upsells' });
        this.cart.renderContents(res);
      })
      .catch((err) => console.error('Cart Add Error:', err))
      .finally(() => {
        this.classList.remove('is-loading');
        this.cart.classList.remove('is-empty');
        this.cart.setNotLoading();
      });
  }

  removeFromCart(variantIds) {
    if (this.classList.contains('is-loading')) return;

    this.classList.add('is-loading');

    const sections = this.cart.getSectionsToRender().map((s) => s.id);
    const formData = new FormData();
    formData.set('sections', sections);

    variantIds.forEach((id) => {
      formData.append(`updates[${id}]`, 0);
    });

    fetch(`${window.routes.cart_update_url}.js`, {
      method: 'POST',
      body: formData
    })
      .then((res) => res.ok ? res.json() : Promise.reject(res))
      .then((res) => {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vbb-cart-extra-upsells' });
        this.cart.renderContents(res);
        if (res.item_count <= 0) {
          this.cart.classList.add('is-empty');
        }
      })
      .catch((err) => console.error('Cart Remove Error:', err))
      .finally(() => {
        this.classList.remove('is-loading');
        this.cart.setNotLoading();
      });
  }
}

customElements.define('vbb-cart-extra-upsells', CartExtraUpsells);
